import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processMultiLineDiscountData = (
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const validationData = processValidation(validation);

  return {
    title: 'Multi-Line Discount',
    description: '',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      remarks: remarks.length > 0 ? remarks[0].text : 'No remarks',
    },
  };
};
